export const editSwotText = [{
    key: 'text_data',
    type: 'textarea',
    value: '',
    valid: false,
    elementConfig: {
        name: 'text_data',
        placeholder: ''
    },
    validation: {
        required: true,
        message: "is required"
    },

}]


// WEBPACK FOOTER //
// ./src/_pages/Organzation/SuperAdminArea/SwotText/formData.js